import { z } from 'zod';

// IMPORTANT: If you change the schema, you must also update the version number
export const SEARCH_HISTORY_SCHEMA_VERSION = '1.2';

export const SavedEntityType = {
  Release: 'Release',
  Artist: 'Artist',
  Playlist: 'Playlist',
  Collector: 'Collector',
} as const;

export type SavedEntityType = (typeof SavedEntityType)[keyof typeof SavedEntityType];

const SavedEntitySchema = z.object({
  id: z.string().uuid(),
  date: z.number(),
  name: z.string(),
  subText: z.string().nullable(),
  type: z.nativeEnum(SavedEntityType),
});

export type SavedEntity = z.infer<typeof SavedEntitySchema>;

export const SearchHistoryStoreSchema = z.object({
  history: z.array(SavedEntitySchema),
});

export type SearchHistoryStoreState = z.infer<typeof SearchHistoryStoreSchema>;
